import { Component, OnInit, ChangeDetectorRef, AfterViewInit, VERSION, ElementRef, TemplateRef,Input } from '@angular/core';
import { Design } from '../designTest/designTest.model'
import { FormGroup, FormControl, FormBuilder, Validators, NgForm, ValidationErrors } from '@angular/forms';
import { AuthenticationService, Item, TestData, Category, Complexity, Type, Checkqset, Question_Counter, Style } from '../services/authentication.service';
import { Router } from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';
import { TestSchedulerService } from '../services/test_scheduler.service';
import { MatStepper } from '@angular/material';
import { QuestionSet, QuestionSetService } from '../services/questionset.service';
import { ViewChild } from '@angular/core';
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { faThumbsDown } from '@fortawesome/free-solid-svg-icons';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import Swal from 'sweetalert2';
import { ActivatedRoute} from '@angular/router';
import { CloneService } from '../services/cloneset.service';


@Component({
  selector: 'app-cloneqnset',
  templateUrl: './clone-question-set.component.html',
  styleUrls: ['./clone-question-set.component.scss']
})


  export class CloneqnsetComponent implements OnInit, AfterViewInit {
    
    private ngVersion: string = VERSION.full;
    @ViewChild('stepper') private myStepper: MatStepper;
    @ViewChild("text") text: ElementRef;
    @ViewChild("content") modalContent: TemplateRef<any>;
    @ViewChild("edit") modalEdit: TemplateRef<any>;
    q_set: Checkqset = { qsetname: '' }
    totalStepsCount: number;
    p: number = 1;
    qnset:any;
    selectedCategory: string;
    array1:any =[];
    array2:any =[];
    selectedCategoryindex: string;
    fieldArray: Array<Design> = [];
    duplicate_fieldArray: any = [];
    array: Array<Design> = [];
    categoryName: Array<Design> = [];
    typeName: Array<Design> = [];
    complexityName: Array<Design> = [];
    newAttribute: any = {};
    newAttribute2: any = {};
    question_set_config: any;
    question_set_config_details: any;
     category_name: any;
    Question_Category: any;
    emptyRow: any;
    result: boolean;
   fieldArrayHistory: any[] = [];
   AddArray: any[] = [];
   deleteArray:any[]=[]
    details: boolean;
    typevalue: boolean = true;
    isDuplicate: boolean = false;
    Category: any;
    Type: any;
    Complexity: string | any[];
    complexityId: string;
    fname: string;
    lname: string;
    user: string;
    userAdmin: boolean;
    userSuperAdmin: boolean;
    userTestScheduler: boolean;
    userTestTaker: boolean;
    questionset: boolean;
    scheduletest: boolean;
    mobileQuery: MediaQueryList;
    elsecount: boolean;
    savebtn: boolean;
    categorybtn: boolean;
    setEmptyCheck: boolean;
    qpEmptyCheck: boolean;
    patternEmpty: boolean;
    typebtn: boolean;
    complexitybtn: boolean;
    countbtn: boolean;
    countbtn1: boolean;
    durationbtn: boolean;
    durationbtn1: boolean;
    overall: boolean;
    evaluate: boolean;
    question_set_arr: any = [];
    questionset_config: any =[];
    private _mobileQueryListener: () => void;
    category: Category = {
      category_name: ''
    };
    sy: any = {
      sy: ''
    };
  
    
    type: Type = {
      cate_id: '',
      subcategory_id: '',
      style_id:''
    };
    complexity: Complexity = {
      cate_id: '',
      subcategory_id: '',
      type_id: ''
    };
    questioncount: Question_Counter = {
      Category_id: '',
      SubCategory_id: '',
      Complexity_id: '',
      type_id: '',
      style_id:''
    };
    style: Style = {
      cate_id: '',
      subcategory_id: ''
    }
  
    test: TestData = {
      id: '',
      FirstName: '',
      LastName: '',
      Email: '',
      Phone: '',
      Type: ''
    };
  
    designTest = new FormGroup({
      questionsetname: new FormControl(''),
      category: new FormControl(''),
      subcategory: new FormControl(''),
      type: new FormControl(''),
      complexity: new FormControl(''),
      count: new FormControl('')
    });
  
    myForm: FormGroup;
    submitted = false;
    unique: any;
    x: string;
    qpValidationCheck: boolean;
    myset: FormGroup;
    categoryEmptyCheck: boolean;
    subCategoryEmptyCheck: boolean;
    typeEmptyCheck: boolean;
    complexityEmptyCheck: boolean;
    countEmptyCheck: boolean;
    durationEmptyCheck: boolean;
    y: any;
    countValidationCheck: boolean;
    durationValidationCheck: boolean;
    name: boolean;
    qset: string;
    duplicate: boolean;
    subcategorybtn: boolean;
    Question_Sub_Category: any;
    selectedsubCategoryindex: any;
    selectedComplexityindex: any;
    selectedtypeindex: any;
    selectedsubCategory: any;
    selectedtype: any;
    selectedComplexity: any;
    questionCounter: any;
    question_count: any;
    question_counter: any;
    org_questioncount: boolean;
    Typelist: any;
    question_typelist: any;
    check_set: any = [];
    lastelem: number;
    duplicate_set_config: boolean;
    field_push: number;
    next: number = 0;
    validation_fail: number = 0;
    modalRef: any;
    set: any = [];
    cardopen: number = 0;
    card_opened: boolean = false;
    dupfield: number = 0;
    field: any = [];
    create_next_counter: number = 0;
    gettablecount: number = 0;
    finalset: any = [];
    setnextcounter: number = 0;
    fielder: any = [];
    delete_counter: number = 0;
    editcard_array: any = [];
    editcard_array1: any = [];
    updateset: any = [];
    setindex: string;
    sectionEmptyCheck: boolean;
    section_name: any = [];
    fielder_last_elem: number;
    lastindex_deleted: Boolean = false
    fieldduplicatearray: any = [];
    section: any;
  
    type_array: {};
    complexity_array: {};
    nextCounter: number = 0;
    tableIndex: number = 0;
    disableDeleteButton: boolean =false;
    counter: 6;
    questionstyleEmptyCheck: boolean;
    typedquestionStyle: any;
    enteredquestionStyle: any;
    question_stylelist: any;
    question_stylelist_filtered: any;
    userEvaluator: boolean;
  
   

  
    constructor(private fb: FormBuilder, private auth: AuthenticationService, private router: Router, private clone: CloneService,
      private qs: QuestionSetService, private testschedulerservice: TestSchedulerService, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, private modal: NgbModal,private route: ActivatedRoute) {
      this.data();
      this.getAccess();
      this.simpletest();
      this.cloneqnset();
      this.mobileQuery = media.matchMedia('(max-width: 600px)');
      this._mobileQueryListener = () => changeDetectorRef.detectChanges();
      this.mobileQuery.addListener(this._mobileQueryListener);
      this.createForm();
      
  
    }
  
    get No_of_Candidates() { return this.myForm.get('No_of_Candidates'); }
  
  
    ngOnInit() {
     
      this.qnset=this.route.snapshot.params;
      this.cloneqnset();
     
     
        
       
      
      this.getTempRowData();
     
      this.get_section_name();
    
    }
  
    ngAfterViewInit() {
      this.totalStepsCount = this.myStepper._steps.length;
    }
  
    createForm() {
      this.myForm = this.fb.group({
        questionsetname: ['', Validators.required],
        No_of_Candidates: ['', [Validators.required]],
        Unique_or_NonUnique: ['', Validators.required],
      });
  
    }
    get f() { return this.myForm.controls; }
  
  
  
    countValidator(control: FormControl): ValidationErrors | null {
  
      let cntval = control.value;
      if (cntval <= 0) {
  
        return {
          cntError: 'Count should be greater than zero.'
        };
      }
      return null;
    }

    simpletest() {
      this.testschedulerservice.test_scheduler(this.test).subscribe(
        (data) => {
  
          this.user = sessionStorage.getItem('user');
          this.fname = sessionStorage.getItem('fname');
  
          this.lname = sessionStorage.getItem('lname');
  
  
          return this.result;
        },
        err => {
          console.error(err);
        }
      );
    }
  
    
    getAccess(){
      this.user = sessionStorage.getItem('user');
      this.fname = sessionStorage.getItem('fname');
  
      this.lname = sessionStorage.getItem('lname');
  
  
      if (this.user === '1') {
        this.userAdmin = true;
        this.userTestScheduler = false;
        this.userEvaluator = false;
      } else if (this.user === '2') {
        this.userEvaluator = true;
        this.userAdmin = false;
        this.userTestScheduler = false;
      } else if (this.user === '3') {
        this.userTestScheduler = true;
        this.userAdmin = false;
        this.userEvaluator = false;  
      }
    }
  
    
  
    

  // this return categoryname and it id

    data() {
      
      this.auth.category(this.category).subscribe(
        (data) => {
  
          this.Question_Category = data.results;
          
          this.details = true;
          return this.Question_Category;


        },
        err => {
          console.error(err);
        }
      );
    }
  
    get_section_name() {
      this.auth.section_name(this.category).subscribe(
        (data) => {
  
          this.section_name = data.results;
        
          this.details = true;
          return this.section_name;
        },
        err => {
          console.error(err);
        }
      );
    }
  
    
    getTempRowData() {
      
      this.newAttribute = {
        question_set_id: '', questionsetname: '', No_of_Candidates: '', Unique_or_NonUnique: '', category: '', subcategory: '', type: '',style:'', typelist: [], typelistshow: true,  complexity: '', count: '', duration: '', subcategory_name: '',
        complexity_name: '', type_name: '',style_name: '', category_name: '', section_name: '', section: ''
      };
  
  
      this.fieldArray.push(this.newAttribute);
}
   
  
 cloneqnset(){
     
      const set:any = this.route.snapshot.params;
      
      this.clone.clone_set_details(set).subscribe(
        (data) => {
          this.question_set_arr = data.results
         
  
          this.get_question_set_config(set)
        }
      )
 }

    get_question_set_config(set: QuestionSet){

      this.qs.get_set_config_details(set).subscribe(
        (data) =>{
          
          this.question_set_config = data;

         
            
          
  
        
        }
      )
    }
   
    setNameChange(){
      this.setEmptyCheck = false
    }


    checkqset() {
      // this.q_set.qsetname=this.question_set_arr[0].Question_Set_Name// qnsetname getting
      this.auth.check_qset(this.q_set).subscribe(
        (data) => {
  
          if (data.code == 204) {
            this.duplicate = true
          }
          else {
            this.duplicate = false;
          }
  
          if ((this.duplicate) === false && (this.qpValidationCheck) === false && (this.qpEmptyCheck) === false && (this.setEmptyCheck) === false && (this.patternEmpty) === false) {
           
           
         
            this.nextCounter += 1
            this.goForward();
          
  
  
          }
        },
        err => {
          console.error(err);
        }
  
      );
  
    }
    patternChange(){
      this.patternEmpty = false
    }

    create_next() {

     
          
      
          //this.create_next_counter = this.create_next_counter + 1
          this.x = this.question_set_arr[0].No_of_Candidates
      
          var candi = +this.x;
      
          this.q_set.qsetname = this.question_set_arr[0].Question_Set_Name
          this.checkqset();
      
      
      
          if (this.question_set_arr[0].Question_Set_Name == '') {
            this.setEmptyCheck = true;
      
          }
          else {
            this.setEmptyCheck = false;
      
          }
          if (this.question_set_arr[0].No_of_Candidates == '') {
            this.qpEmptyCheck = true;
          }
          else {
            this.qpEmptyCheck = false;
          }
          if (candi <= 0) {
            this.qpValidationCheck = true;
          }
          else {
            this.qpValidationCheck = false;
          }
          if (this.question_set_arr[0].Unique_or_NonUnique == '') {
            this.patternEmpty = true;
          }
          else {
            this.patternEmpty = false;
          }
      
      
        }
        goForward() {

          if(this.nextCounter == 1)
          {
            this.fielder.push(this.newAttribute)
          }
          this.myStepper.next();
          
      
        }
       
        open_set_card(index: any) {
          this.cardopen = this.cardopen + 1
          let ngbModalOptions: NgbModalOptions = {
            backdrop: 'static',
            keyboard: false
          };
          this.modalRef = this.modal.open(this.modalContent, ngbModalOptions)
           if (this.cardopen > 1) {
            this.card_opened = true
            this.set.splice(0, this.set.length)
            this.dupfield = this.dupfield + 1;
            if (this.dupfield > 1) {
              this.duplicate_fieldArray.splice(0, this.duplicate_fieldArray.length)
            
            }

      

            this.duplicate_fieldArray.push(this.newAttribute)
            
          }
         
        }

       
        getcolor(){}

//change handler


sectionchange(event: any, field : any) {

  let sample = event.target.value;
  let flag =0;
 
  for (var i = 0; i < this.section_name.length; i++) {
    if(this.section_name[i].Section_Name == sample)
    { 
      flag=1;
      field.section = this.section_name[i].Id;
      
    }
  } 
  if(flag == 0)
  {
    field.section = null;
  }
}

categorychange(event: any, field : any) {

    let sample = event.target.value
   
    for (var i = 0; i < this.Question_Category.length; i++) {
      if(this.Question_Category[i].Id == sample)
      {
        
        field.category_name = this.Question_Category[i].Category_Name;
        
      }
    } 
}

subcategorychange(event: any, field : any) {

  let sample = event.target.value
  for (var i = 0; i < this.Question_Sub_Category.length; i++) {
    if(this.Question_Sub_Category[i].Id == sample)
    {
      field.subcategory_name = this.Question_Sub_Category[i].Sub_Category_Name;
     
    }
  } 
}
 

typechange(event: any, field : any) {

  let sample = event.target.value
 
  for (var i = 0; i < this.question_typelist.length; i++) {
    if(this.question_typelist[i].typeid == sample)
    {
      field.type_name = this.question_typelist[i].Name;
      
    }
  } 
}

complexitychange(event: any, field : any) {

  let sample = event.target.value
  
  for (var i = 0; i < this.Complexity.length; i++) {
    if(this.Complexity[i].Id == sample)
    {
      field.complexity_name = this.Complexity[i].Complexity_Name;
      
    }
  } 
}

sectionNameChange(event: any, field : any)
{
  this.sectionEmptyCheck = false
  let sample = event.target.value;
  let flag =0;
  field.section_name = sample;
  
  for (var i = 0; i < this.section_name.length; i++) {
    if(this.section_name[i].Section_Name == sample)
    { 
      flag=1;
      field.section = this.section_name[i].Id;
      
    }
  } 
  
  if(flag == 0)
  {
    field.section = null;
  }
}



//add config details
selectChangeHandler(event: any, i: any) {

  var map = new Map();

  this.categoryEmptyCheck = false

  this.selectedCategoryindex = i;

  this.selectedCategory = event.target.value;

  
  this.category.category_name = this.selectedCategory //here set category_ID in cat

  this.type.cate_id = this.selectedCategory
  this.complexity.cate_id = this.selectedCategory
  this.style.cate_id = this.selectedCategory
  

  this.auth.subcategory(this.category).subscribe(
    (data) => {

      this.Question_Sub_Category = data.results;
      
      
      this.details = true;
      return this.Question_Sub_Category;
    },
    err => {
      console.error(err);
    }
  );
}

//complexity changehandler
complexityChangeHandler(event: any, i: any) {

  this.complexityEmptyCheck = false
  this.selectedComplexityindex = i;

  this.selectedComplexity = event.target.value;
 
}

//type changehandler
typeChangeHandler(event: any, i: any) {

  this.typeEmptyCheck = false

  this.selectedtypeindex = i;

  this.selectedtype = event.target.value;

  this.complexity.type_id = this.selectedtype

  this.auth.complexity(this.complexity).subscribe(
    (data) => {

      this.Complexity = data.results;
     
     
      this.details = true;
      return this.Complexity;
      
    },
    err => {
      console.error(err);
    }
  );

}

//count changehandler
countChangeHandler(event: any, i: any , field : any) {


  this.countEmptyCheck = false
  this.countValidationCheck = false
  this.org_questioncount = false

 

  this.question_counter = field.count//entered count
   

  
  this.questioncount.Category_id = this.selectedCategory
  if(this.Complexity.length == 1){
    
    this.selectedComplexity = this.Complexity[0].Id
    this.questioncount.Complexity_id = this.Complexity[0].Id
  }else{
  this.questioncount.Complexity_id = this.selectedComplexity
  }
  this.questioncount.SubCategory_id = this.selectedsubCategory
  this.questioncount.type_id = this.selectedtype
  this.questioncount.style_id = this.enteredquestionStyle
 


  this.auth.subcategory_count(this.questioncount).subscribe(
    (data) => {


      this.questionCounter = data.results[0].count;
      
      if (this.question_counter > this.questionCounter) {
        this.org_questioncount = true
      }
      else {
        this.org_questioncount = false
      }
    },
    err => {
      console.error(err);
    }
  );
  // }

}

//subcategory changehandler
subcategoryChangeHandler(event: any, i: any) {

  this.subCategoryEmptyCheck = false
  this.selectedsubCategoryindex = i;

  this.selectedsubCategory = event.target.value;


  this.complexity.subcategory_id = this.selectedsubCategory
  this.type.subcategory_id = this.selectedsubCategory
  this.style.subcategory_id = this.selectedsubCategory

  this.auth.style(this.style).subscribe(
    data => {
  
      this.question_stylelist = data.results;
     
      this.details = true;

     
      return this.question_stylelist;


    },
    err => {
      console.error(err);
    }
  );



}


onclickStyleDropdown(){


  if(this.Question_Sub_Category.length == 1){
    this.complexity.subcategory_id = this.Question_Sub_Category[0].Id
    this.type.subcategory_id = this.Question_Sub_Category[0].Id
    this.style.subcategory_id = this.Question_Sub_Category[0].Id
    this.selectedsubCategory = this.Question_Sub_Category[0].Id
  }

  this.auth.style(this.style).subscribe(
    data => {
  
      this.question_stylelist = data.results;
    
   
      this.details = true;

     
      return this.question_stylelist;


    },
    err => {
      console.error(err);
    }
  );
}

onclickTypeDropdown(){
 
  if(this.question_stylelist.length == 1){
    this.type.style_id = this.question_stylelist[0].styleid
    this.enteredquestionStyle = this.question_stylelist[0].styleid
  }
  
  this.auth.type(this.type).subscribe(
    (data) => {
   

      this.question_typelist = data.results;
  
      
      this.details = true;
     // return this.Complexity;
      return this.question_typelist;
    },
    err => {
      console.error(err);
    }
  );
}

onclickComplexityDropdown(){

  if(this.question_typelist.length == 1){
    this.complexity.type_id = this.question_typelist[0].typeid
    this.selectedtype= this.question_typelist[0].typeid
  }

  
  this.auth.complexity(this.complexity).subscribe(
    (data) => {

      this.Complexity = data.results;
        
      this.details = true;
      return this.Complexity;
      
    },
    err => {
      console.error(err);
    }
  );
}

questionStyleChangeHandler(event: any) {
  this.questionstyleEmptyCheck = false;
 
 

  this.enteredquestionStyle = event.target.value;

  
  
  this.type.style_id = this.enteredquestionStyle;
  
  
  this.auth.type(this.type).subscribe(
    (data) => {
    

      this.question_typelist = data.results;

      
      this.details = true;
     // return this.Complexity;
      return this.question_typelist;
    },
    err => {
      console.error(err);
    }
  );
}

durationChange()
  {
    this.durationEmptyCheck = false
    this.durationValidationCheck = false
  }



  qpCountChange()
  {
    this.qpEmptyCheck = false
    this.qpValidationCheck = false
  }

//save&next
set_next() {
  

 
  
  if (this.delete_counter === 1) {
    this.fielder.push(this.newAttribute)
  
    
  }
  if (this.lastindex_deleted === true) {
    this.fieldArray.push(this.newAttribute)

  }

  this.disableDeleteButton = false



  this.lastindex_deleted = false
  this.delete_counter = 0


  this.field_push = this.fieldArray.length - 1



  this.set.push(this.fieldArray[this.field_push])
  this.setnextcounter = this.setnextcounter + 1

  


  this.validation_fail = 0



  for (let i = 0; i <= this.fieldArray.length - 1; i++) {
    this.x = this.fieldArray[i].count
   


    var count = +this.x;

    this.y = this.fieldArray[i].duration

    var duration = +this.y;
    if (this.fieldArray[i].category === '') {
      this.categoryEmptyCheck = true;
     
    }
    else {
      this.categoryEmptyCheck = false;

    }
    if (this.fieldArray[i].subcategory === '') {
      this.subCategoryEmptyCheck = true;
     
    }
    else {
      this.subCategoryEmptyCheck = false;

    }
    if (this.fieldArray[i].section === '') {
      this.sectionEmptyCheck = true;
      // alert("Enter Correct Question Set details")
    }
    else {
      this.sectionEmptyCheck = false;

    }
    if (this.fieldArray[i].type === '') {
      this.typeEmptyCheck = true;
    }
    else {
      this.typeEmptyCheck = false;
    }

    if (this.fieldArray[i].style === '') {
      this.questionstyleEmptyCheck = true;
    }
    else {
      this.questionstyleEmptyCheck = false;
    }
    if (this.fieldArray[i].complexity === '') {
      this.complexityEmptyCheck = true;
    }
    else {
      this.complexityEmptyCheck = false;
    }
    if (this.fieldArray[i].count === '') {
      this.countEmptyCheck = true;
    }
    else {
      this.countEmptyCheck = false;
    }
    if (count <= 0) {
      this.countValidationCheck = true;
    }
    else {
      this.countValidationCheck = false;
    }
    if (this.fieldArray[i].duration === '') {
      this.durationEmptyCheck = true;
    }
    else {
      this.durationEmptyCheck = false;
    }
    if (duration <= 0) {
      this.durationValidationCheck = true;
    }
    else {
      this.durationValidationCheck = false;
    }
    if (this.question_counter > this.questionCounter) {
      this.org_questioncount = true
    }
    else {
      this.org_questioncount = false
    }

    if (((this.durationValidationCheck === false) && (this.countValidationCheck === false) && (this.countEmptyCheck === false) && (this.categoryEmptyCheck === false) && (this.typeEmptyCheck === false) && (this.org_questioncount === false))) {
      if ((this.subCategoryEmptyCheck === false) && (this.sectionEmptyCheck === false) && (this.questionstyleEmptyCheck === false)) {
        if (this.durationEmptyCheck === false) {
          if (this.complexityEmptyCheck === false) {


            this.validation_fail = this.validation_fail + 1
          }

        }
      }


    }
  }


  if (this.validation_fail == this.fieldArray.length) {
     this.check_set_configuration()

  }
  else {
    this.fieldArray.splice(-1, 1);
    this.fieldArray.push(this.newAttribute)
  }

}

check_set_configuration() {
  //alert("wrong")
  this.duplicate_set_config = false;
  this.field_push = this.fieldArray.length - 1
if(this.check_set.length === 0){
  for (let i = 0; i < this.question_set_config.length; i++) {
    const config = this.question_set_config[i];

  
    const finalObj: Record<string,any>={};
    finalObj["questionsetname"]= this.question_set_arr[0].Question_Set_Name;
    finalObj["No_of_Candidates"]= this.question_set_arr[0].No_of_Candidates.toString();
    finalObj["Unique_or_NonUnique"]= this.question_set_arr[0].question_pattern;
    finalObj["question_set_id"]= "";
    finalObj["category"]= config.Category_Id.toString();
    finalObj["category_name"]= config.Category_Name;
    finalObj["complexity"]= config.Complexity_Id.toString();
    finalObj["complexity_name"]= config.Complexity_Name;
    finalObj["count"]= config.Count.toString();
    finalObj["duration"]= config.Duration.toString();
    finalObj["section"]= config.Section_Id;
    finalObj["section_name"]= config.Section_Name;
    finalObj["style"]=  config.Style_Id.toString();
    finalObj["style_name"]= config.style_name;
    finalObj["subcategory"]= config.Subcategory_Id.toString();
    finalObj["subcategory_name"]=config.Sub_Category_Name;
    finalObj["type"]=config.Type_Id.toString(); 
    finalObj["type_name"]= config.Name;
    finalObj["typelist"]= [];
    finalObj["typelistshow"]=true;

    this.check_set.push(finalObj)
  }
}

  this.check_set.push(this.fieldArray[this.field_push])
  
  this.lastelem = this.check_set.length - 1;
  if (this.check_set.length > 1) {
    for (var i = 0; i < this.check_set.length - 1; i++) {

      
      if (this.check_set[this.lastelem].category == this.check_set[i].category && this.check_set[this.lastelem].subcategory == this.check_set[i].subcategory && this.check_set[this.lastelem].type == this.check_set[i].type && this.check_set[this.lastelem].complexity == this.check_set[i].complexity && this.check_set[this.lastelem].style == this.check_set[i].style) {

        this.duplicate_set_config = true;
        Swal.fire({
          title: 'Alert',
          text: 'Duplicate Set Config',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'OK'
        }).then((result) => {
          if (result.isConfirmed) {
            
            // this.check_set=[];
          }
         
        })
        
        this.check_set.splice(-1, 1);
       
      }

    
     
        this.qs.gettabledata(this.set).subscribe(
          (data) => {
      
      
          this.gettablecount = this.check_set.length - 1
          
            
      
           
       this.category_name= this.check_set[this.lastelem].category_name = data.results[0].Category_Name

            this.check_set[this.lastelem].subcategory_name = data.results[0].Sub_Category_Name
            this.check_set[this.lastelem].type_name = data.results[0].Name
            this.check_set[this.lastelem].style_name = data.results[0].Style_Name
            this.check_set[this.lastelem].complexity_name = data.results[0].Complexity_Name;
      
            this.gettablecount = this.gettablecount + 1
            
      

    
      
          },
          err => {
            console.error(err);
          }
        );

        // if(!this.isDuplicate){
        //   console.log("Close modal....")
        //   this.modalRef.close(this.modalContent)

        // }
      
        // this.modalRef.close(this.modalContent)
       
          
       

    }
    if (this.duplicate_set_config != true && this.org_questioncount == false) {
      console.log("Inside duplicate_set_config ")

      const len = this.question_set_config.length;
      

      




      for (let i = this.check_set.length-1; i > this.check_set.length-2; i--) {

       
const config = this.check_set[i];

this.qs.gettabledata(this.set).subscribe(
  (data) => {


  this.gettablecount = this.check_set.length - 1
 
    

   
this.category_name= this.check_set[this.lastelem].category_name = data.results[0].Category_Name

    this.check_set[this.lastelem].subcategory_name = data.results[0].Sub_Category_Name
    this.check_set[this.lastelem].type_name = data.results[0].Name
    this.check_set[this.lastelem].style_name = data.results[0].Style_Name
    this.check_set[this.lastelem].complexity_name = data.results[0].Complexity_Name;
   
    this.gettablecount = this.gettablecount + 1
    


const final: Record<string,any>={};

final["Category_Id"]= parseInt(config.category);
final["Category_Name"]=config.category_name;
final["Complexity_Id"]= parseInt(config.complexity);
final["Complexity_Name"]= config.complexity_name.toString();
final["Count"]= parseInt(config.count);
final["Duration"]= parseInt(config.duration);
final["Id"]= "";
final["Name"]= config.type_name;
final["Section_Id"]= parseInt(config.section);
final["Section_Name"]= config.section_name;
final["Style_Id"]=  parseInt(config.style);
final["Sub_Category_Name"]=config.subcategory_name;
final["Subcategory_Id"]= parseInt(config.subcategory);
final["Type_Id"]=parseInt(config.type); 
final["style_name"]= config.style_name;

this.question_set_config.push(final)
this.modalRef.close(this.modalContent)


  },
  
  err => {
    console.error(err);
  }
);

      }
      this.getTempRowData()
       this.getsectionid()
      
     

     
      this.modalRef.close(this.modalContent)
    }


  }
  else {
    if (this.org_questioncount == false) {

      this.getTempRowData()
      this.getsectionid()
     
       
      this.modalRef.close(this.modalContent)
    }

  }

}

getsectionid(){
  if(this.fielder[this.gettablecount].section == null)
  {
    this.qs.getsectionid(this.set).subscribe(
      (data) => {

        this.gettablecount = this.check_set.length -1
        this.fielder[this.gettablecount].section = data.results[0].insertId
       
      })
  }
}

deleteFieldValue(index: number) {
  this.delete_counter = 0;

  this.gettablecount = this.gettablecount - 1
  this.tableIndex = index
  

  

  
  this.question_set_config.splice(index, 1);
  this.check_set.splice(index, 1);
  this.delete_counter = this.delete_counter + 1

  

}
goNext() {

  this.nextCounter = 0
  this.myStepper.next();
  this.design();
}
design() {

  for (let i = 0; i < this.question_set_config.length; i++) {
    const config = this.question_set_config[i];

   
    const finalObj: Record<string,any>={};
    finalObj["questionsetname"]= this.question_set_arr[0].Question_Set_Name;
    finalObj["No_of_Candidates"]= this.question_set_arr[0].No_of_Candidates.toString();
    finalObj["Unique_or_NonUnique"]= this.question_set_arr[0].question_pattern;
    finalObj["question_set_id"]= "";
    finalObj["category"]= config.Category_Id.toString();
    finalObj["category_name"]= config.Category_Name;
    finalObj["complexity"]= config.Complexity_Id.toString();
    finalObj["complexity_name"]= config.Complexity_Name;
    finalObj["count"]= config.Count.toString();
    finalObj["duration"]= config.Duration.toString();
    finalObj["section"]= config.Section_Id;
    finalObj["section_name"]= config.Section_Name;
    finalObj["style"]=  config.Style_Id.toString();
    finalObj["style_name"]= config.style_name;
    finalObj["subcategory"]= config.Subcategory_Id.toString();
    finalObj["subcategory_name"]=config.Sub_Category_Name;
    finalObj["type"]=config.Type_Id.toString(); 
    finalObj["type_name"]= config.Name;
    finalObj["type_name"]= config.Name;
    finalObj["typelist"]= [];
    finalObj["typelistshow"]=true;
   
    this.fieldArrayHistory.push(finalObj)
  
    

   
  }
 

  // for (let i = 0; i <= this.fieldArrayHistory.length; i++) {

   
    var name = this.fname + " " + this.lname
  
    this.auth.designTest(this.fieldArrayHistory,name).subscribe(
      
      (data) => {
      
        this.submitted = true;

        if (data.code === 200) {
        console.log("success")
        } else {
         

        }
      },
      err => {
        console.error(err);
          console.log("failed")
      }
    );
  // }
}

generateSet() {



  this.qs.generateSet(this.fieldArrayHistory).subscribe(
    
    (data) => {

      if (data.code === 200) {
       
        Swal.fire({
          title: 'Success',
          text: data.success,
          icon: 'success',
          showCancelButton: false,
          confirmButtonText: 'OK'
        }).then((result) => {
          if (result.isConfirmed) {
            this.router.navigateByUrl('/question_set');
          }
        })
      }else if (data.code === 400) {
        Swal.fire({
          title: 'Alert',
          text: data.failed,
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'OK'
        }).then((result) => {
          if (result.isConfirmed) {
            
          }
        })

      }
    },
    err => {
      console.error(err);
    }
  );
}
open_edit_card(index: string) {
  this.cardopen = this.cardopen + 1
  this.get_section_name();
  this.editcard_array = [];
  localStorage.setItem('setindex', index)

  this.question_set_config[index]

   const finalObj: Record<string,any>={};
            finalObj["questionsetname"]= this.question_set_arr[0].Question_Set_Name;
            finalObj["No_of_Candidates"]= this.question_set_arr[0].No_of_Candidates.toString();
            finalObj["Unique_or_NonUnique"]= this.question_set_arr[0].question_pattern;
            finalObj["question_set_id"]= "";
            finalObj["category"]= this.question_set_config[index].Category_Id.toString();
            finalObj["category_name"]= this.question_set_config[index].Category_Name;
            finalObj["complexity"]= this.question_set_config[index].Complexity_Id.toString();
            finalObj["complexity_name"]= this.question_set_config[index].Complexity_Name;
            finalObj["count"]= this.question_set_config[index].Count.toString();
            finalObj["duration"]= this.question_set_config[index].Duration.toString();
            finalObj["section"]= this.question_set_config[index].Section_Id;
            finalObj["section_name"]= this.question_set_config[index].Section_Name;
            finalObj["style"]= this.question_set_config[index].Style_Id.toString();
            finalObj["style_name"]=this.question_set_config[index].style_name;
            finalObj["subcategory"]= this.question_set_config[index].Subcategory_Id.toString();
            finalObj["subcategory_name"]=this.question_set_config[index].Sub_Category_Name;
            finalObj["type"]=this.question_set_config[index].Type_Id.toString(); 
            finalObj["type_name"]= this.question_set_config[index].Name;
            finalObj["typelist"]= [];
            finalObj["typelistshow"]=true;
         
            this.editcard_array.push(finalObj)
  
  localStorage.setItem('setindex', index)

  
 
  this.category.category_name =this.editcard_array[0].category;
   
  
this.auth.subcategory(this.category).subscribe(
(data) => {

  this.Question_Sub_Category = data.results;
  
  
  this.details = true;
  return this.Question_Sub_Category;

},
err => {
  console.error(err);
}
);
this.style.subcategory_id = this.editcard_array[0].subcategory;
this.style.cate_id = this.editcard_array[0].category;
this.auth.style(this.style).subscribe(
data => {

  this.question_stylelist = data.results;
  

  this.details = true;

 
  return this.question_stylelist;


},
err => {
  console.error(err);
}
);
this.type.subcategory_id = this.editcard_array[0].subcategory;
this.type.cate_id = this.editcard_array[0].category;
this.type.style_id = this.editcard_array[0].style;


this.auth.type(this.type).subscribe(
(data) => {
 

  this.question_typelist = data.results;

  
  this.details = true;
 // return this.Complexity;
  return this.question_typelist;
},
err => {
  console.error(err);
}
);
this.complexity.subcategory_id = this.editcard_array[0].subcategory;
this.complexity.cate_id = this.editcard_array[0].category;
this.complexity.type_id = this.editcard_array[0].type;
this.auth.complexity(this.complexity).subscribe(
(data) => {

  this.Complexity = data.results;
  
 
  this.details = true;
  return this.Complexity;
  
},
err => {
  console.error(err);
}
);



  let ngbModalOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false
  };

  // if(this.editcard_array[0].category != 0)
  // {

  this.modalRef = this.modal.open(this.modalEdit, ngbModalOptions)
  // }



}


update_set(index: any , field: {
  type_name: any; subcategory_name: any; complexity_name: any; category: string; subcategory: string; style: string; style1: string; category_name: any; complexity: string; count: string; duration: string; section: string; section_name: any; type: string; 
}) {
  this.updateset = this.updateset + 1
  this.setindex = localStorage.getItem('setindex')

  



  
  
   if(true){
    this.category.category_name =field.category
         
          
      this.auth.subcategory(this.category).subscribe(
        (data) => {
  
          this.Question_Sub_Category = data.results;
         
          const matchingItem = this.Question_Sub_Category.find((item: { Id: any; Sub_Category_Name: any }) => {
            
            if (item.Id == this.selectedsubCategory) {
              
          
           
        
              return true;
            }
          
            return false;
          });
          
          
          

          
          
        
          
          
          this.details = true;

       
          return this.Question_Sub_Category;
        },
        err => {
          console.error(err);
        }
      );
   
    this.style.subcategory_id = field.subcategory;
    this.style.cate_id = field.category;
    this.auth.style(this.style).subscribe(
    data => {
    
      this.question_stylelist = data.results;
     
    
      this.details = true;
     
      

     
      if(this.question_stylelist != ""){
      this.question_stylelist.forEach((item: { styleid: any; Name: any; }) => {
  
        if (item.styleid === field.style) {
         
          console.log('Found matching item:', item.Name);
        
         
        }
      });
 
    }
   

   
      return this.question_stylelist[0].Name,this.question_stylelist[0].styleid;
    
    
    },
    err => {
      console.error(err);
    }
    );
  
  


  
    this.type.subcategory_id = field.subcategory;
    this.type.cate_id = field.category;
    this.type.style_id =this.question_stylelist[0].styleid;
   
    
    this.auth.type(this.type).subscribe(
    (data) => {
    
    
      this.question_typelist = data.results;
      const matchingItem =this.question_typelist.find((item1: { typeid: any; Name: any }) => {
      
        if (item1.typeid == this.selectedtype ) {
          
      
          
          return true;
        }
      
        return false;
      });
      
    
      
      this.details = true;
     


  return this.question_typelist;
    },
    err => {
      console.error(err);
    }
    );
  
    this.complexity.subcategory_id =  field.subcategory;
    this.complexity.cate_id = field.category;
    this.complexity.type_id =this.question_typelist[0].typeid;
    this.auth.complexity(this.complexity).subscribe(
      (data) => {
  
        this.Complexity = data.results;
      
       
        this.details = true;
      
        return this.Complexity ;
        
      },
      err => {
        console.error(err);
      }
    );
    
  



  const final1: Record<string,any>={};

  final1["category"]= parseInt(field.category);
final1["category_name"]=field.category_name;
final1["complexity"]= parseInt(field.complexity);
final1["complexity_name"]=field.complexity_name;
final1["count"]= parseInt(field.count);
final1["duration"]= parseInt(field.duration);
final1["type_name"]= this.question_typelist[0].Name;
final1["section"]= parseInt(field.section);
final1["section_name"]= field.section_name;
final1["style"]=  parseInt(field.style);
final1["subcategory_name"]= field.subcategory_name;
final1["subcategory"]= parseInt(field.subcategory);
final1["type"]=parseInt(field.type); 
final1["style_name"]= this.question_stylelist[0].Name;
final1["typelist"]= [];
final1["typelistshow"]=true;

this.editcard_array[0]=final1;


 

   }
  const final2: Record<string,any>={};
  final2["Category_Id"]= parseInt(this.editcard_array[0].category);
final2["Category_Name"]=this.editcard_array[0].category_name;
final2["Complexity_Id"]= parseInt(this.editcard_array[0].complexity);
final2["Complexity_Name"]= this.editcard_array[0].complexity_name;
final2["Count"]= parseInt(this.editcard_array[0].count);
final2["Duration"]= parseInt(this.editcard_array[0].duration);
final2["Id"]= "";
final2["Name"]= this.editcard_array[0].type_name;
final2["Section_Id"]= parseInt(this.editcard_array[0].section);
final2["Section_Name"]= this.editcard_array[0].section_name;
final2["Style_Id"]=  parseInt(this.editcard_array[0].style);
final2["Sub_Category_Name"]=this.editcard_array[0].subcategory_name;
final2["Subcategory_Id"]= parseInt(this.editcard_array[0].subcategory);
final2["Type_Id"]=parseInt(this.editcard_array[0].type); 
final2["style_name"]= this.editcard_array[0].style_name;

this.question_set_config[this.setindex]=final2;
this.array2.splice(-1, 1)

  this.modalRef.close(this.modalEdit)


  
}

 
  
  }
  
  